import { Link } from "react-router-dom";
import { fileUrl } from "@/lib/api";
import { usePrefs, formatPrice } from "@/context/PreferencesContext";

export function ProductCard({ product }) {
  const { currency, language } = usePrefs();
  const price = formatPrice(product.price || 0, currency, language);
  const img = product.images?.[0];
  return (
    <Link
      to={`/produits/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="product-card group block border border-white/10 hover:border-[#FF3B00] transition-colors bg-[#0A0A0A]"
    >
      <div className="aspect-square overflow-hidden bg-[#111] relative">
        {img ? (
          <img
            src={fileUrl(img)}
            alt={product.name}
            className="product-img w-full h-full object-cover"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-white/20 font-display text-4xl">MERCH</div>
        )}
        {product.limited_edition && (
          <div className="absolute top-3 left-3 bg-[#FF3B00] text-white text-[10px] uppercase tracking-widest px-2 py-1">
            {language === "en" ? "Limited Edition" : "Édition Limitée"}
          </div>
        )}
        {product.stock === 0 && (
          <div className="absolute inset-0 bg-black/70 flex items-center justify-center font-display text-3xl uppercase text-white/80">
            {language === "en" ? "Sold Out" : "Rupture"}
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="text-xs uppercase tracking-widest text-white/40">{product.artist_name}</div>
        <div className="mt-1 text-sm font-medium truncate">{product.name}</div>
        <div className="mt-2 font-display text-2xl">{price.display}</div>
      </div>
    </Link>
  );
}
